import type { PropsWithChildren } from 'react';

import type { SiteContent } from '../../content/types';
import { FloatingChatbot } from '../chat/floating-chatbot';
import { MobileStickyCta } from './mobile-sticky-cta';
import { SiteFooter } from './site-footer';
import { SiteHeader } from './site-header';

interface AppShellProps extends PropsWithChildren {
  content: SiteContent;
}

export function AppShell({ content, children }: AppShellProps): JSX.Element {
  return (
    <div className="min-h-screen bg-[color:var(--color-background)] pb-20 text-[color:var(--color-text)] lg:pb-0">
      <SiteHeader content={content} />
      <main>{children}</main>
      <SiteFooter content={content} />
      <FloatingChatbot content={content} />
      <MobileStickyCta content={content} />
    </div>
  );
}
